import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {}

const FolderFileCloseIcon: React.FC<Props> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.53879 4.88841C4.96683 5.60638 4.66675 6.73388 4.66675 8.34168V15.6546C4.66675 17.1846 5.11564 18.3078 5.85749 19.0482C6.59954 19.7888 7.72603 20.2374 9.26127 20.2374H16.5576C18.0885 20.2374 19.2119 19.7891 19.9521 19.0488C20.6923 18.3084 21.1405 17.185 21.1405 15.6546V15.6503L21.1667 10.9989C21.1667 10.9982 21.1667 10.9974 21.1667 10.9967C21.1664 9.34966 20.8621 8.28723 20.3051 7.63506C19.7711 7.00979 18.8744 6.61421 17.3115 6.61421H14.6582H14.656C13.7483 6.61159 12.894 6.18456 12.3475 5.45983L12.3468 5.45893L11.4909 4.32027C11.2278 3.96997 10.816 3.76367 10.3795 3.76367H8.50443C6.97858 3.76367 6.08234 4.20612 5.53879 4.88841ZM4.36558 3.95377C5.27693 2.80978 6.67453 2.26367 8.50443 2.26367H10.3795C11.2894 2.26367 12.1446 2.69295 12.6899 3.41896C12.6898 3.41886 12.69 3.41906 12.6899 3.41896L13.5452 4.55672C13.545 4.55653 13.5453 4.55691 13.5452 4.55672C13.8088 4.90593 14.2212 5.11265 14.6594 5.11421H17.3115C19.1122 5.11421 20.518 5.57458 21.4458 6.66095C22.3503 7.72012 22.6667 9.22438 22.6667 10.9989V11.0031L22.6405 15.6546C22.6405 15.6553 22.6405 15.6561 22.6405 15.6568C22.64 17.4802 22.0996 19.0224 21.0128 20.1093C19.9255 21.1968 18.3825 21.7374 16.5576 21.7374H9.26127C7.43299 21.7374 5.88723 21.1971 4.79789 20.1099C3.70836 19.0225 3.16675 17.4793 3.16675 15.6546V8.34168C3.16675 6.59858 3.48264 5.06208 4.36558 3.95377Z"
        fill={props.fill || "currentColor" || "#D22D3D"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.5954 10.874C10.8882 10.5811 11.3631 10.5811 11.656 10.874L12.9167 12.1347L14.1765 10.8749C14.4694 10.582 14.9443 10.582 15.2372 10.8749C15.5301 11.1678 15.5301 11.6427 15.2372 11.9356L13.9775 13.1953L15.2362 14.4541C15.5292 14.747 15.5292 15.2219 15.2362 15.5148C14.9433 15.8077 14.4684 15.8077 14.1755 15.5148L12.9167 14.256L11.6571 15.5158C11.3642 15.8086 10.8892 15.8086 10.5963 15.5158C10.3035 15.2229 10.3035 14.748 10.5963 14.4551L11.8561 13.1953L10.5954 11.9346C10.3025 11.6417 10.3025 11.1669 10.5954 10.874Z"
        fill={props.fill || "currentColor" || "#D22D3D"}
      />
    </svg>
  );
};

export default FolderFileCloseIcon;
